export default "__VITE_ASSET__BqGYMZJc__"